/* eslint-disable unicorn/consistent-destructuring */
import { B64File } from 'common/classes/B64File.class';
/**
 * Un produit de la boutique
 */
export class BoutiqueProduitImage {
    /**
     * Constructeut de l'objet
     * @param row Paramètres du constructeur
     */
    constructor(boutiqueProduitImage) {
        if (boutiqueProduitImage) {
            const { idProduitImage, idProduit, idCouleur, file, url, dateEnregistrement, actif } = boutiqueProduitImage;
            this.idProduitImage = idProduitImage;
            this.idProduit = idProduit;
            this.idCouleur = idCouleur;
            this.file = file ? new B64File(file) : url ? new B64File(B64File.pathUrlToFile(url)) : null;
            this.dateEnregistrement = dateEnregistrement;
            this.actif = actif;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQm91dGlxdWVJbWFnZS5jbGFzcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIkJvdXRpcXVlSW1hZ2UuY2xhc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEscURBQXFEO0FBQ3JELE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSw4QkFBOEIsQ0FBQztBQUV2RDs7R0FFRztBQUNILE1BQU0sT0FBTyxvQkFBb0I7SUFvQ2hDOzs7T0FHRztJQUNILFlBQW1CLG9CQUFvRDtRQUN0RSxJQUFJLG9CQUFvQixFQUFFO1lBQ3pCLE1BQU0sRUFBRSxjQUFjLEVBQUUsU0FBUyxFQUFFLFNBQVMsRUFBRSxJQUFJLEVBQUUsR0FBRyxFQUFFLGtCQUFrQixFQUFFLEtBQUssRUFBRSxHQUFHLG9CQUFvQixDQUFDO1lBRTVHLElBQUksQ0FBQyxjQUFjLEdBQUcsY0FBYyxDQUFDO1lBQ3JDLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1lBQzNCLElBQUksQ0FBQyxTQUFTLEdBQUcsU0FBUyxDQUFDO1lBQzNCLElBQUksQ0FBQyxJQUFJLEdBQUcsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLE9BQU8sQ0FBQyxPQUFPLENBQUMsYUFBYSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztZQUM1RixJQUFJLENBQUMsa0JBQWtCLEdBQUcsa0JBQWtCLENBQUM7WUFDN0MsSUFBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUM7U0FDbkI7SUFDRixDQUFDO0NBQ0QifQ==